import script from "./UnityWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnityWidget.vue?vue&type=script&lang=ts&setup=true"

import "./UnityWidget.vue?vue&type=style&index=0&id=2058d117&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2058d117"]])

export default __exports__